import { PAT } from "@/constants/testIds";

export const NEW_ENCOUNTER_BUTTON = {
  testId: PAT.chartNewEncounter,
  label: "+ New Encounter",
};

export const OUTPATIENT_NEW_ENCOUNTER_DEFAULTS = {
  status: "planned",
  class: "AMB",
  type: "",
};

export function newEncounterFormState(patientId) {
  return {
    patientId: patientId || "",
    locationId: "",
    start: "",
    end: "",
    ...OUTPATIENT_NEW_ENCOUNTER_DEFAULTS,
  };
}

export function encounterScreenPath(created, options = {}) {
  if (!created?.id) return null;
  const base = `/encounters/${encodeURIComponent(created.id)}`;
  return options.noteId ? `${base}?note=${encodeURIComponent(options.noteId)}` : base;
}

export function isNoteOrNoteVersionWrite(url) {
  const path = String(url || "");
  return /\/notes(\/|$)/.test(path) || /\/versions(\/|$)/.test(path);
}
